import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMegaphone32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMegaphone32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20.94 4.108c1.332-.832 3.06.125 3.06 1.696v15.392c0 1.57-1.728 2.528-3.06 1.696L14.713 19H12v6.335a2.665 2.665 0 0 1-5.266.578L5.09 18.515A4 4 0 0 1 3 15v-3a4 4 0 0 1 4-4h7.713zM15 17h-2v-7h2.287l.243-.152L22 5.804v15.392l-6.47-4.044-.243-.152zm-8-7h4v7H7a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m.247 9 1.44 6.48A.665.665 0 0 0 10 25.335V19zM29 10a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMegaphone32);
